import { Button, Menu, MenuItem, Popover, Position } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import React from 'react';
import { useHistory } from 'react-router-dom';
import AppToaster from '../../../AppToaster';
import { EmployeeInfoFragment, useDeleteEmployeeMutation } from '../../../generated/graphql';
import { showErrorMessage } from '../../../helpers/graphql';

type EmployeeDetailMenuProps = {
  employee: EmployeeInfoFragment;
  onEdit: () => void;
};

const EmployeeDetailMenu = ({ employee, onEdit }: EmployeeDetailMenuProps) => {
  const history = useHistory();
  const [deleteEmployee, { loading: deleting }] = useDeleteEmployeeMutation({
    variables: {
      id: employee.id,
    },
    onError: showErrorMessage,
    onCompleted: () => {
      AppToaster.success(`${employee.display_name}  wurde in den Papierkorb gelegt`);
      history.goBack();
    },
  });

  return (
    <>
      <Button text="Bearbeiten" icon={IconNames.EDIT} className="ml-2" onClick={onEdit} />
      <Popover
        position={Position.BOTTOM}
        content={
          <Menu>
            <MenuItem text="In den Papierkorb" icon={IconNames.TRASH} onClick={deleteEmployee as any} />
          </Menu>
        }
      >
        <Button icon={IconNames.MORE} className="ml-2" loading={deleting} />
      </Popover>
    </>
  );
};

export default EmployeeDetailMenu;
